import React, { useContext, useState } from 'react'
import { Input as AntdInput } from 'antd'
import cls from 'classnames'
import PropTypes from 'prop-types'
import styled, { ThemeContext } from 'styled-components'

import withValidation from '../inputs/withValidation'
import LabelText from '../LabelText'

import { View, ViewOff } from './Icons'

const Input = ({
  id,
  value,
  defaultValue,
  onChange,
  meta = {},
  placeholder,
  labelText,
  disabled,
  name,
  type,
  onFocus,
  notification,
  className,
  style,
  ...otherProps
}) => {
  const theme = useContext(ThemeContext)
  const [view, setView] = useState(false)
  const [currentType, setCurrentType] = useState(type)
  const toggleView = () => {
    setView((prevView) => !prevView)
    setCurrentType(currentType === 'password' ? 'text' : type)
  }
  return (
    <div className={className} style={style}>
      {labelText && (
        <LabelText
          text={labelText}
          style={disabled && { color: theme.ds_gray_5 }}
          notification={notification}
        />
      )}
      <AntdInput
        {...otherProps}
        id={id}
        type={currentType}
        className={cls({ error: meta.error && meta.touched })}
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
        meta={meta}
        placeholder={placeholder}
        disabled={disabled}
        name={name}
        onFocus={onFocus}
        suffix={
          type === 'password' ? (
            view ? (
              <ViewOff onClick={toggleView} />
            ) : (
              <View onClick={toggleView} />
            )
          ) : null
        }
      />
    </div>
  )
}

Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  placeholder: PropTypes.string,
  labelText: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.oneOf(['password', 'text']),
  onFocus: PropTypes.func,
  notification: PropTypes.oneOf([PropTypes.string, PropTypes.element]),
  style: PropTypes.object,
}

export default styled(withValidation(Input))`
  .ant-input-affix-wrapper {
    padding: 0 12px;
  }

  & > input,
  .ant-input-affix-wrapper {
    width: 100%;
    height: 36px;
    border: 1px solid ${({ theme }) => theme.ds_gray_6};
    border-radius: 4px;
    padding: 0 12px;
    color: #2f354a;
    font-size: ${({ theme }) => theme.typography.size.body};
    box-shadow: none;

    ${(props) =>
      props.size === 'small' &&
      `
      height: 32px;
    `}

    ${(props) =>
      props.size === 'large' &&
      `
      height: 40px;
    `}

    @media screen and (max-width: ${(props) => props.theme.rcPhonePointMin}) {
      height: 32px;
    }

    &.error {
      border: 1px solid #e44258;
    }

    &:hover {
      border-color: ${({ theme }) => theme.buttonHover};
    }

    &:focus {
      border: 1px solid #2e41ea;
      outline: none;
      box-shadow: none;
    }

    &[disabled] {
      background-color: #fff;
      border: 1px solid #e6e9ee;
      cursor: default;

      &::placeholder {
        color: #aaabb8;
      }
    }

    &::placeholder {
      font-size: 14px;
      color: #8e8fa0;
    }
  }
`
